import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import ServiceOptions from "./sections/ServiceOptions";
import DeliverablesOverview from "./sections/DeliverablesOverview";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <HeroBanner />
      <ServiceOptions />
      <DeliverablesOverview />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}